export var PaymentSettings;
(function (PaymentSettings) {
    PaymentSettings["REFIL_ENABLED"] = "REFIL_ENABLED";
    PaymentSettings["SUBSCRIPTIONS_ENABLED"] = "SUBSCRIPTIONS_ENABLED";
    PaymentSettings["PAYMENT_METHODS_REQUIRED"] = "PAYMENT_METHODS_REQUIRED";
    PaymentSettings["REGISTRATION_CREDITS"] = "REGISTRATION_CREDITS";
    PaymentSettings["THRESHOLD_VALUE"] = "THRESHOLD_VALUE";
    PaymentSettings["THRESHOLD_COOLDOWN"] = "THRESHOLD_COOLDOWN";
})(PaymentSettings || (PaymentSettings = {}));
//# sourceMappingURL=payment-settings.js.map